<template>
  <WizardStep
    v-if="hasSetLogoPermission || hasSetBannerPermission"
    heading=""
    :hideFooter="true"
  >
    <template v-slot:content>
      <div>
        <KTPortlet
          v-if="hasSetLogoPermission"
          title=""
          v-bind:class="'kt-portlet--height-fluid'"
          v-bind="{ bodyFit: true }"
          class="Logo-Upload-Settings"
        >
          <template v-slot:body>
            <b-jumbotron v-if="logo && showLogo" class="logo-set">
              <b-img :src="logo" @error="showLogo = false" fluid-grow />
            </b-jumbotron>
            <ImageCrop
              placeholder="Select new logo image"
              v-bind:aspect="logo_aspect"
              v-on:cropped="setLogoImage"
              v-on:cropping="showLogo = false"
              v-on:croppingCancelled="showLogo = true"
              v-if="!uploadingLogo"
            ></ImageCrop>
          </template>
          <template v-slot:foot>
            <b-progress
              v-if="uploadingLogo"
              :value="logoUploadProgress"
              :max="logoUploadMax"
              show-progress
              animated
            ></b-progress>
            <b-btn
              v-if="newLogoSelected && !uploadingLogo"
              right
              variant="primary"
              @click="uploadImageData(logo, 'logo', updateLogoProgress)"
              >Upload</b-btn
            >
          </template>
        </KTPortlet>

        <KTPortlet
          v-if="hasSetBannerPermission"
          title=""
          v-bind:class="'kt-portlet--height-fluid'"
          v-bind="{ bodyFit: true }"
          class="Logo-Upload-Settings"
        >
          <template v-slot:body>
            <b-jumbotron v-if="banner && showBanner" class="logo-banner">
              <b-img :src="banner" @error="showBanner = false" fluid-grow />
            </b-jumbotron>
            <ImageCrop
              placeholder="Select new banner image   "
              v-bind:aspect="banner_aspect"
              v-on:cropped="setBannerImage"
              v-on:cropping="showBanner = false"
              v-on:croppingCancelled="showBanner = true"
              v-if="!uploadingBanner"
            ></ImageCrop>
          </template>
          <template v-slot:foot>
            <b-progress
              v-if="uploadingBanner"
              :value="bannerUploadProgress"
              :max="bannerUploadMax"
              show-progress
              animated
            ></b-progress>
            <b-btn
              v-if="newBannerSelected && !uploadingBanner"
              right
              variant="primary"
              @click="uploadImageData(banner, 'banner', updateBannerProgress)"
              >Upload</b-btn
            >
          </template>
        </KTPortlet>
      </div>
    </template>
  </WizardStep>
</template>

<script>
import WizardStep from "@/components/wizard/WizardStep";
import ImageCrop from "@/components/widgets/ImageCrop";
import KTPortlet from "@/views/partials/content/Portlet.vue";
import Amplify, { Storage } from "aws-amplify";
import { GET_USER_ATTRIBUTES } from "@/store/auth.module";
import MerchantSettingsPermissionsMixin from "@/components/merchantsettings/MerchantSettingsPermissionsMixin.js";

export default {
  mixins: [MerchantSettingsPermissionsMixin],
  components: { WizardStep, ImageCrop, KTPortlet },
  props: ["heading"],
  data() {
    return {
      mime_type: "image/png",
      banner_aspect: 7.667,
      logo_aspect: 3,
      logo: null,
      banner: null,
      logoUploadProgress: 0,
      logoUploadMax: 0,
      bannerUploadProgress: 0,
      bannerUploadMax: 0,
      newBannerSelected: false,
      newLogoSelected: false,
      uploadingLogo: false,
      uploadingBanner: false,
      showLogo: true,
      showBanner: true
    };
  },
  methods: {
    setLogoImage(data) {
      this.logo = data;
      this.newLogoSelected = true;
    },
    setBannerImage(data) {
      this.banner = data;
      this.newBannerSelected = true;
    },
    uploadImageData(data, name, callback) {
      if (name == "banner") {
        if (!this.hasSetBannerPermission) return;
        this.uploadingBanner = true;
      }
      if (name == "logo") {
        if (!this.hasSetLogoPermission) return;
        this.uploadingLogo = true;
      }

      const vm = this;
      this.urltoFile(data, `${name}.png`, this.mime_type).then(function(file) {
        vm.uploadToBucket(name, file, callback);
      });
    },
    uploadToBucket: async function(folder, content, callback) {
      Storage.put(`merchant/${folder}/${await this.getMerchantId()}`, content, {
        contentType: this.mime_type,
        progressCallback(progress) {
          callback(progress);
        }
      })
        .then(key => {
          //do something with this key
          if (folder == "banner") {
            this.uploadingBanner = false;
            this.newBannerSelected = false;
          }
          if (folder == "logo") {
            this.uploadingLogo = false;
            this.newLogoSelected = false;
          }
        })
        .catch(err => {
          this.$logger.error(err);
          //handle error
        });
    },
    updateLogoProgress(progress) {
      this.logoUploadProgress = progress.loaded;
      this.logoUploadMax = progress.total;
    },

    updateBannerProgress(progress) {
      this.bannerUploadProgress = progress.loaded;
      this.bannerUploadMax = progress.total;
    },
    urltoFile(url, filename, mimeType) {
      return fetch(url)
        .then(function(res) {
          return res.arrayBuffer();
        })
        .then(function(buf) {
          return new File([buf], filename, { type: mimeType });
        });
    },
    async getMerchantId() {
      var result = null;
      await this.$store.dispatch(GET_USER_ATTRIBUTES).then(attributes => {
        result = attributes["family_name"];
      });
      if (!result) throw new Error("No merchantId exists for this user.");
      return result;
    },
    async loadExistingImages() {
      const vm = this;
      Storage.get(`merchant/banner/${await this.getMerchantId()}`)
        .then(result => {
          vm.banner = result;
        })
        .catch(err => {
          vm.$logger.error(err);
          vm.banner = null;
        });

      Storage.get(`merchant/logo/${await this.getMerchantId()}`)
        .then(result => {
          vm.logo = result;
        })
        .catch(err => {
          vm.$logger.error(err);
          vm.logo = null;
        });
    }
  },
  async beforeMount() {
    await this.loadExistingImages();
  }
};
</script>

<style>
.logo-set {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  border-style: dashed;
  color: #aaa3da;
}
.logo-banner {
  border-style: dashed;
  color: #aaa3da;
}

.Logo-Upload-Settings {
  border-color: transparent !important;
  box-shadow: none !important;
}
.Logo-Upload-Settings > .kt-portlet__body {
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-file-label {
  border-style: none;
  border-color: transparent;
}

.custom-file-label::after {
  background-color: transparent;
  color: #897fca;
}
</style>
